/*
 * @Author: your name
 * @Date: 2021-08-04 15:25:39
 * @LastEditTime: 2021-12-04 16:59:13
 * @LastEditors: cmx
 * @Description: In User Settings Edit
 */
import { RouteConfig } from 'vue-router';
import Layout from '@/layouts/layout.vue';

const activityCommonRoute: RouteConfig[] = [
    // {
    //     path: '/activeCreate.html',
    //     component: Layout,
    //     redirect: '/activeCreate.html',
    //     children: [
    //         {
    //             path: '/',
    //             component: () => import('@/views/activity_common/create.vue'),
    //         },
    //     ],
    // },
    {
        path: '/activeManagement.html',
        component: Layout,
        redirect: '/activeManagement.html',
        name: 'activeManagement',
        children: [
            {
                path: '/',
                component: () => import('@/views/activity_common/management.vue'),
                meta: { title: '管理后台', parentTab: 'voting' },
            },
        ],
    }
];

export { activityCommonRoute };
